import React from 'react'

import {
  Grid,
  Chart,
} from 'components/UI'

const TemperatureChartTitle = ({ title }) => (
  <Grid.Row>
    <Grid.Col>
      <h2>{title}</h2>
    </Grid.Col>
    <Grid.Col>
      <Chart.TemperatureLegend small />
    </Grid.Col>
  </Grid.Row>
)

export default TemperatureChartTitle



// WEBPACK FOOTER //
// ./src/components/UI/Chart/TemperatureChartTitle.jsx